<template>
  <div class="page-container">
    <span class="parent-path">藥洗紀錄 / </span><span class="current-path">編輯藥洗紀錄</span>
    <span class="page-title">編輯藥洗紀錄</span>
    <div class="card-content">
      <a-form @submit.prevent="handleSubmit" class="company-form">

        <div class="section">
          <h2>執行資訊</h2>
          <div class="form-grid">
            <a-form-item :validateStatus="errors.date ? 'error' : ''" :help="errors.date">
              <a-label for="date">日期</a-label>
              <a-date-picker v-model:value="form.date" class="picker" placeholder="請選擇日期"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.date ? 'error' : ''" :help="errors.time">
              <a-label for="time">時間</a-label>
              <a-time-picker v-model:value="form.time" format="HH:mm" class="picker" placeholder="請選擇時間"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.address ? 'error' : ''" :help="errors.address">
              <a-label for="user">執行人員</a-label>
              <a-select v-model:value="form.user_id" placeholder="請輸入執行人員" style="display: block"
                        @change="handleChange">
                <a-select-option
                    v-for="item in users"
                    :key="item.id"
                    :value="item.id">
                  {{ item.last_name }}{{ item.first_name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :validateStatus="errors.note ? 'error' : ''" :help="errors.note">
              <a-label for="note">備註</a-label>
              <a-textarea v-model:value="form.note" id="representative" type="text" placeholder="請填寫備註"/>
            </a-form-item>
          </div>
        </div>

        <div class="section">
          <h2>設備資訊</h2>
          <div class="form-grid">
            <a-form-item :validateStatus="errors.device_name ? 'error' : ''" :help="errors.device_name">
              <a-label for="lastName">設備名稱</a-label>
              <a-input v-model:value="form.device_name" id="lastName" type="text" placeholder="請輸入設備名稱"/>
            </a-form-item>
          </div>
        </div>

        <div class="form-actions">
          <a-button type="button" class="btn-cancel" @click="handleCancel">取消</a-button>
          <a-button html-type="submit" class="btn-submit">儲存</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);


export default {
  inject: ['getSelectedCompany'],
  data() {
    return {
      users: [],
      form: {
        date: "",
        time: "",
        user_id: null,
        note: "",
        device_name: ""
      },
      errors: {
        date: "",
        time: "",
        user: "",
        note: "",
        device_name: ""
      }
    };
  },
  mounted() {
    this.users = this.getSelectedCompany().users

    const token = localStorage.getItem('token');
    this.$axios.get(`/api/cleaning-logs/${this.$route.params.id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      console.log("jesse log", response.data.data)
      this.form = response.data.data
      this.form.user_id = response.data.data.user.id

      this.form.date = dayjs(response.data.data.time)
      this.form.time = dayjs(response.data.data.time)
      console.log("jesse log form", this.form)
    }).catch(error => {
      console.error(error);
      if (error.status === 401) {
        this.$router.push('/login');
      }
    });
  },
  methods: {
    handleSubmit() {
      console.log("表單提交", this.form);

      for (let key in this.errors) {
        this.errors[key] = ""
      }

      let date = dayjs(this.form.date).format("YYYY-MM-DD");
      let time = dayjs(this.form.time).format("HH:mm");
      console.log("jesse log", `${date} ${time}`)

      const token = localStorage.getItem('token');
      this.$axios.patch(`/api/cleaning-logs/${this.$route.params.id}`, {
        time: dayjs(`${date} ${time}`).utc().format("YYYY-MM-DD HH:mm"),
        user_id: this.form.user_id,
        note: this.form.note,
        device_name: this.form.device_name
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        console.log(response)
        message.success("已完成藥洗紀錄編輯")
        this.$router.go(-1)
      }).catch(error => {
        console.log(error);
        if (error.status === 401) {
          this.$router.push('/login');
        } else {
          console.log(error.response.data);
          let errors = error.response.data
          for (let key in errors) {
            this.errors[key] = errors[key]['message']
          }
        }
      });
    },
    handleCancel() {
      console.log("取消操作");
      this.$router.go(-1)
    },
  },
};
</script>

<style scoped>
.card-content {
  background-color: white;
  border-radius: 8px;
  width: 1024px;
  padding: 20px;
  margin-top: 28px;
}

h1 {
  font-size: 1.5em;
  margin-bottom: 1em;
}

.section {
  margin-bottom: 2em;
}

.section h2 {
  font-size: 1.2em;
  margin-bottom: 1em;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
}

/*.form-group {*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*}*/

label {
  font-size: 0.9em;
  margin-bottom: 0.5em;
  color: #333;
}

input {
  padding: 0.7em;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 4px;
}

input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.picker {
  display: block;
  padding: 10px 10px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1em;
}

.btn-cancel {
  background-color: #f8f9fa;
  color: #333;
}

.btn-submit {
  background-color: #007bff;
  color: white;
}

.btn-submit:hover {
  background-color: #0056b3;
}
</style>
